(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aurvex-instagram"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aurvex-night-gallery')) {
  customElements.define('aurvex-night-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.track = this.querySelector('.axig__track');
      this.cards = [...this.querySelectorAll('[data-night-card]')];
      this.dots = [...this.querySelectorAll('[data-night-dot]')];
      if (!this.track || !this.cards.length) return;
      this.abort = new AbortController();
      const options = { signal:this.abort.signal };
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.active = -1;
      const initial = this.cards.findIndex(card => card.dataset.bg?.toUpperCase() === '#14120E');
      this.setActive(initial >= 0 ? initial : 0);
      this.frame = requestAnimationFrame(() => this.center(this.active, false));
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.readCenter());
      }, { ...options, passive:true });
      this.track.addEventListener('keydown', event => {
        const direction = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!direction) return;
        event.preventDefault();
        this.center(Math.max(0,Math.min(this.cards.length-1,this.active+direction)),true);
      },options);
      this.cards.forEach((card,index) => card.addEventListener('click',() => this.center(index,true),options));
      this.dots.forEach((dot,index) => dot.addEventListener('click',() => this.center(index,true),options));
      this.addEventListener('shopify:block:select', event => {
        const index = this.cards.indexOf(event.target.closest('[data-night-card]'));
        if (index >= 0) this.center(index,false);
      },options);
      this.lastWidth = this.track.clientWidth;
      this.resize = new ResizeObserver(() => {
        if (this.lastWidth === this.track.clientWidth) return;
        this.lastWidth = this.track.clientWidth;
        this.center(this.active,false);
      });
      this.resize.observe(this.track);
    }
    center(index,animate) {
      const card = this.cards[index];
      if (!card) return;
      const trackRect = this.track.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      const left = this.track.scrollLeft + cardRect.left + cardRect.width/2 - trackRect.left - this.track.clientWidth/2;
      this.track.scrollTo({ left, behavior:animate && !this.reduced.matches ? 'smooth' : 'instant' });
      if (!animate || this.reduced.matches) this.setActive(index);
    }
    readCenter() {
      const rect = this.track.getBoundingClientRect();
      const midpoint = rect.left + this.track.clientWidth/2;
      let nearest = 0, distance = Infinity;
      this.cards.forEach((card,index) => {
        const bounds = card.getBoundingClientRect();
        const delta = Math.abs(bounds.left+bounds.width/2-midpoint);
        if (delta < distance) { distance=delta;nearest=index; }
      });
      this.setActive(nearest);
    }
    setActive(index) {
      if (index === this.active) return;
      this.active = index;
      const card = this.cards[index];
      this.style.setProperty('--axig-bg',card.dataset.bg || '#14120E');
      this.style.setProperty('--axig-ink',card.dataset.ink || '#F6F2EA');
      this.cards.forEach((item,i) => item.classList.toggle('is-active',i===index));
      this.dots.forEach((dot,i) => dot.setAttribute('aria-pressed',String(i===index)));
      const status = this.querySelector('[data-night-status]');
      if (status) status.textContent = card.dataset.label;
    }
    disconnectedCallback() {
      this.abort?.abort();this.abort=null;
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);cancelAnimationFrame(this.scrollFrame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurvex-leaderboard"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ax-leaderboard')) {
  customElements.define('ax-leaderboard', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.level = 'extreme';
      this.period = 'today';
      this.cache = {};
      this.list = this.querySelector('[data-list]');
      this.onClick = event => {
        const level = event.target.closest('[data-level]');
        const period = event.target.closest('[data-period]');
        if (level) { this.level = level.dataset.level; this.select('[data-level]', level); this.load(); }
        if (period) { this.period = period.dataset.period; this.select('[data-period]', period); this.draw(); }
      };
      this.onRefresh = event => {
        const level = event.detail && event.detail.level;
        if (level) { delete this.cache[level]; this.level = level; this.select('[data-level]', this.querySelector('[data-level="' + level + '"]')); }
        this.load(true);
      };
      this.addEventListener('click', this.onClick);
      window.addEventListener('axlb:refresh', this.onRefresh);
      this.load();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('axlb:refresh', this.onRefresh);
      this.ready = false;
    }
    select(selector, active) {
      this.querySelectorAll(selector).forEach(button => button.setAttribute('aria-selected', String(button === active)));
    }
    async load(fresh) {
      const level = this.level;
      if (this.cache[level] && !fresh) { this.draw(); return; }
      this.message(this.dataset.load);
      try {
        const url = this.dataset.board.replace(/\/$/, '') + '/top?level=' + level + '&limit=' + (this.dataset.limit || 10) + (fresh ? '&t=' + Date.now() : '');
        const res = await fetch(url);
        if (!res.ok) throw new Error(res.status);
        this.cache[level] = await res.json();
        if (level === this.level) this.draw();
      } catch (error) {
        if (level === this.level) this.message(this.dataset.err);
      }
    }
    message(text) {
      this.list.innerHTML = '';
      const li = document.createElement('li');
      li.className = 'axlb__empty';
      li.textContent = text || '';
      this.list.appendChild(li);
      this.querySelector('[data-count]').textContent = '';
    }
    fmt(ms) {
      const seconds = ms / 1000;
      const m = Math.floor(seconds / 60);
      const s = (seconds - m * 60).toFixed(1);
      return m + ':' + (s.length < 4 ? '0' + s : s);
    }
    draw() {
      const data = this.cache[this.level];
      if (!data) return;
      const rows = data[this.period] || [];
      if (!rows.length) { this.message(this.dataset.empty); }
      else {
        this.list.innerHTML = '';
        rows.forEach((row, index) => {
          const li = document.createElement('li');
          li.className = 'axlb__row';
          const rank = document.createElement('span');
          rank.className = 'axlb__rank';
          rank.textContent = String(index + 1).padStart(2, '0');
          const nick = document.createElement('span');
          nick.className = 'axlb__nick' + (row.name ? '' : ' is-anon');
          nick.textContent = row.name || this.dataset.anon;
          const time = document.createElement('span');
          time.className = 'axlb__time';
          time.textContent = data.kind === 'score' ? row.score + ' ' + this.dataset.pts : this.fmt(row.score);
          li.append(rank, nick, time);
          this.list.appendChild(li);
        });
      }
      this.querySelector('[data-count]').textContent = data.total ? data.total + ' ' + this.dataset.runs : '';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurvex-night-sounds"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ax-night-sounds')) {
  customElements.define('ax-night-sounds', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.cards = [...this.querySelectorAll('[data-card]')];
      this.now = this.querySelector('[data-now]');
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) entry.target.classList.add('is-in');
          entry.target.classList.toggle('is-on', entry.isIntersecting);
        }), { threshold: 0.25 });
        this.cards.forEach(card => this.observer.observe(card));
      } else {
        this.cards.forEach(card => card.classList.add('is-in', 'is-on'));
      }
      this.onClick = event => {
        const start = event.target.closest('[data-start]');
        const close = event.target.closest('[data-close]');
        const out = event.target.closest('[data-out]');
        if (start) { this.play(start.closest('[data-card]')); return; }
        if (close) { this.stop(); return; }
        if (out) this.track(out.closest('[data-card]')?.dataset.playlist, out.dataset.out);
      };
      this.addEventListener('click', this.onClick);
    }
    play(card) {
      if (!card || !card.dataset.embed) return;
      const smooth = matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      if (this.current === card) { this.reveal(smooth); return; }
      this.current = card;
      this.cards.forEach(item => {
        const on = item === card;
        item.classList.toggle('is-playing', on);
        const button = item.querySelector('.axns__play');
        if (button) {
          button.setAttribute('aria-pressed', String(on));
          button.querySelector('[data-play-label]').textContent = on ? this.dataset.playing : this.dataset.play;
        }
      });
      const slot = this.now.querySelector('[data-frame]');
      slot.innerHTML = '';
      const frame = document.createElement('iframe');
      frame.src = card.dataset.embed;
      frame.title = card.dataset.frameTitle;
      frame.allow = 'autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture';
      slot.appendChild(frame);
      this.now.querySelector('[data-now-label]').textContent = card.dataset.side + ' · ' + card.dataset.playlist;
      this.now.hidden = false;
      requestAnimationFrame(() => this.reveal(smooth));
      this.track(card.dataset.playlist, 'spotify_embed');
    }
    reveal(behavior) {
      const box = this.now.getBoundingClientRect();
      window.scrollTo({ top: window.scrollY + box.top - Math.max(0, (window.innerHeight - box.height) / 2), behavior });
      this.scrollLeft = 0;
    }
    stop() {
      this.current = null;
      this.now.hidden = true;
      this.now.querySelector('[data-frame]').innerHTML = '';
      this.cards.forEach(item => {
        item.classList.remove('is-playing');
        const button = item.querySelector('.axns__play');
        if (button) {
          button.setAttribute('aria-pressed', 'false');
          button.querySelector('[data-play-label]').textContent = this.dataset.play;
        }
      });
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.removeEventListener('click', this.onClick);
      this.ready = false;
    }
    track(playlist, platform) {
      const data = { playlist, platform, placement: this.dataset.placement };
      try { window.Shopify?.analytics?.publish?.('aurvex_playlist_click', data); } catch (error) {}
      try {
        const pixel = this.dataset.metaPixel;
        if (pixel && typeof window.fbq === 'function') window.fbq('trackSingleCustom', pixel, 'PlaylistClick', data);
      } catch (error) {}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurvex-offline-collection"] && !Shopify.designMode) return;
  try {
    
(() => {
 const start = () => {
  const targets = document.querySelectorAll('.axh-sell__line--sleep,.ax-next-heading__title');
  if (!('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver(entries => {
   entries.forEach(entry => {if(entry.isIntersecting){entry.target.style.animationPlayState='running';observer.unobserve(entry.target);}});
  },{threshold:.3});
  targets.forEach(el => {el.style.animationPlayState='paused';observer.observe(el);});
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 document.addEventListener('shopify:section:load',start);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurvex-password"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ax-launch-clock')) {
    customElements.define('ax-launch-clock', class extends HTMLElement {
      connectedCallback() {
        this.hidden = true;
        const raw = this.dataset.launchAt || '';
        if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(raw)) return;
        this.deadline = Date.parse(raw);
        if (!Number.isFinite(this.deadline)) return;
        clearInterval(this.timer);
        if (this.tick()) this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      tick() {
        const remaining = Math.ceil((this.deadline - Date.now()) / 1000);
        if (remaining <= 0) {
          this.hidden = true;
          clearInterval(this.timer);
          return false;
        }
        const values = {
          days: Math.floor(remaining / 86400),
          hours: Math.floor(remaining / 3600) % 24,
          minutes: Math.floor(remaining / 60) % 60,
          seconds: remaining % 60
        };
        for (const [unit, value] of Object.entries(values)) {
          const node = this.querySelector('[data-unit="' + unit + '"]');
          if (node) node.textContent = String(value).padStart(2, '0');
        }
        this.hidden = false;
        return true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurvex-room-unwind"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ax-room-unwind')) {
  customElements.define('ax-room-unwind', class extends HTMLElement {
    static LIVES = 3;
    static LEVELS = {
      easy: { plan: [[3, 4, 11], [2, 5, 11], [3, 4, 11]], lit: 16, relights: 8, every: [1500, 2200], min: 2, double: 0, ramp: 0, spread: 0, penalty: 0 },
      medium: { plan: [[3, 6, 11], [2, 8, 11], [3, 5, 11]], lit: 20, relights: 16, every: [1200, 1700], min: 0, double: 0.1, ramp: 0.2, spread: 4000, penalty: 0 },
      extreme: { plan: [[4, 6, 8], [3, 7, 8], [4, 5, 8]], lit: 22, relights: 999, every: [918, 1326], min: 0, double: 0.2, ramp: 0.3, spread: 3200, penalty: 0 }
    };
    static FLIGHT = { g: 1250, flap: -390, vmax: 620, x: 110, pw: 26, ph: 16, w: 56, gap0: 190, gapMin: 125, gapTau: 50, v0: 130, vMax: 270, tau: 45, spacing: 230, first: 440, look: 900, ground: 372, crowFrom: 25, crowEvery: [5.5, 8], crowSpeed: 55, crowD: [36, 58], zChance: 0.6, signs: ['SCROLL', 'EMAIL', 'NEWS', 'NOTIF', 'DEADLINE', '1 MORE', 'ALARM', 'CHAT'] };
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      try { this.t = JSON.parse(this.querySelector('[data-t]').textContent); } catch (error) { this.t = {}; }
      this.timers = new Set();
      this.level = this.load('level') || 'medium';
      if (!this.constructor.LEVELS[this.level]) this.level = 'medium';
      this.skin = this.load('skin') || 'mask';
      if (this.constructor.SKINS.indexOf(this.skin) < 0 || !this.skinOpen(this.skin)) this.skin = 'mask';
      this.dlg = this.querySelector('[data-dlg]');
      this.p = {
        kicker: this.querySelector('[data-p-kicker]'),
        title: this.querySelector('[data-p-title]'),
        purpose: this.querySelector('[data-p-purpose]'),
        steps: this.querySelector('[data-p-steps]'),
        levels: this.querySelector('[data-levels]'),
        skins: this.querySelector('[data-skins]'),
        skincur: this.querySelector('[data-skincur]'),
        skinx: this.querySelector('[data-skinx]'),
        stats: this.querySelector('[data-stats]'),
        reward: this.querySelector('[data-reward-box]'),
        go: this.querySelector('[data-go]'),
        again: this.querySelector('[data-again]'),
        next: this.querySelector('[data-next]'),
        redeem: this.querySelector('[data-redeem]'),
        cta: this.querySelector('[data-cta]'),
        board: this.querySelector('[data-board-box]'),
        spotify: this.querySelector('[data-spotify]'),
        back: this.querySelector('[data-back]')
      };
      this.querySelector('[data-go-label]').textContent = this.t.start || '';
      this.querySelector('[data-again-label]').textContent = this.t.again || '';
      this.p.back.textContent = ((this.dataset.placement || '').indexOf(':room') > -1 ? this.t.back : this.t.back_home) || '';
      this.querySelectorAll('[data-level]').forEach(button => { button.textContent = (this.t.levels || {})[button.dataset.level] || button.dataset.level; });
      this.querySelector('[data-reward-title]').textContent = this.t.reward_title || '';
      this.querySelector('[data-reward-note]').textContent = this.fill(this.t.reward_note);
      if (this.querySelector('[data-scene="flight"]')) this.buildSkins();
      this.p.skinx?.addEventListener('close', () => { if (!this.dlg.open) document.documentElement.classList.remove('axru-lock'); this.buildSkins(); });
      this.querySelector('[data-copy]').textContent = this.t.copy || '';
      this.p.redeem.textContent = this.t.redeem || '';
      this.musicOn = this.load('music') !== '0';
      this.musicBtn = this.querySelector('[data-music]');
      this.drawMusic();
      this.boardOn = this.load('board') !== '0';
      this.boardBtn = this.querySelector('[data-board-toggle]');
      if (this.boardBtn && this.dataset.board) { this.boardBtn.hidden = false; this.drawBoard(); }
      this.querySelector('[data-nick-label]').textContent = this.t.nick_label || '';
      this.querySelector('[data-nick-save]').textContent = this.t.nick_save || '';
      this.querySelector('[data-nick-input]').placeholder = this.t.nick_ph || '';
      this.nameForm = this.querySelector('[data-name-form]');
      this.nameInput = this.querySelector('[data-name-input]');
      this.nameInput.placeholder = this.t.nick_ph || '';
      this.nameInput.setAttribute('aria-label', this.t.name_title || '');
      this.querySelector('[data-name-start]').textContent = this.t.name_start || 'START';
      this.querySelector('[data-name-skip]').textContent = this.t.name_skip || '';
      this.who = this.querySelector('[data-who]');
      this.onName = event => { event.preventDefault(); this.submitName(); };
      this.nameForm.addEventListener('submit', this.onName);
      this.onNick = event => { event.preventDefault(); this.saveNick(); };
      this.querySelector('[data-nick-form]').addEventListener('submit', this.onNick);
      this.titles = {
        breathe: this.querySelector('.axru__card--breathe h3').textContent,
        city: this.querySelector('.axru__card--city h3').textContent
      };
      this.purposes = {
        breathe: this.querySelector('.axru__card--breathe [data-purpose]').dataset.purpose,
        city: this.querySelector('.axru__card--city [data-purpose]').dataset.purpose
      };
      this.kickers = {
        breathe: this.querySelector('.axru__card--breathe .axru__kicker').textContent,
        city: this.querySelector('.axru__card--city .axru__kicker').textContent
      };
      this.b = {
        orb: this.querySelector('[data-orb]'),
        phase: this.querySelector('[data-phase]'),
        count: this.querySelector('[data-count]'),
        dots: [...this.querySelectorAll('[data-dots] i')]
      };
      this.c = {
        street: this.querySelector('[data-street]'),
        lit: this.querySelector('[data-lit]'),
        clock: this.querySelector('[data-clock]'),
        lives: this.querySelector('[data-lives]'),
        arena: this.querySelector('.axru__arena--city'),
        toast: this.querySelector('[data-toast]'),
        cd: this.querySelector('[data-cd]')
      };
      this.fl = {
        arena: this.querySelector('.axru__arena--flight'),
        canvas: this.querySelector('[data-flight-canvas]'),
        cd: this.querySelector('[data-flight-cd]'),
        score: this.querySelector('[data-flight-score]'),
        zs: this.querySelector('[data-flight-zs]')
      };
      this.titles.flight = this.querySelector('.axru__card--flight h3').textContent;
      this.purposes.flight = this.querySelector('.axru__card--flight [data-purpose]').dataset.purpose;
      this.kickers.flight = this.querySelector('.axru__card--flight .axru__kicker').textContent;
      // v44 (Lukas 21.10.): Waehrend der Runde zaehlt jeder Tipp auf dem ganzen Spiel-Bildschirm, nicht nur auf der Spielflaeche.
      // Ausnahme: Bedienelemente (X, Ton, Musik, Bestenliste). Kein Scrollen, kein Zoomen, kein Doppeltipp-Zoom.
      const isControl = target => !!(target && target.closest && target.closest('button, a, input, label, [data-close], [data-sound], [data-music], [data-board-toggle]'));
      this.onFlap = event => {
        if (this.kind !== 'flight' || this.state !== 'play') return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (isControl(event.target)) return;
        if (event.cancelable) event.preventDefault();
        this.flap();
      };
      this.onFlightTouch = event => { if (this.kind === 'flight' && (this.state === 'play' || this.state === 'count') && !isControl(event.target) && event.cancelable) event.preventDefault(); };
      this.onKey = event => {
        if (this.kind !== 'flight' || this.state !== 'play') return;
        if (event.code === 'Space' || event.code === 'ArrowUp' || event.key === 'w') { event.preventDefault(); this.flap(); }
      };
      this.dlg.addEventListener('pointerdown', this.onFlap);
      this.dlg.addEventListener('touchstart', this.onFlightTouch, { passive: false });
      this.dlg.addEventListener('touchmove', this.onFlightTouch, { passive: false });
      this.dlg.addEventListener('dblclick', this.onFlightTouch);
      window.addEventListener('keydown', this.onKey);
      this.muted = this.load('muted') === '1';
      this.snd = this.querySelector('[data-sound]');
      this.drawSound();
      this.buildPreview();
      this.buildStars();
      this.onClick = event => {
        const open = event.target.closest('[data-open]');
        if (open) { this.open(open.dataset.open); return; }
        if (event.target.closest('[data-close]')) { this.close(); return; }
        if (event.target.closest('[data-sound]')) { this.muted = !this.muted; this.save('muted', this.muted ? '1' : '0'); this.drawSound(); if (this.muted) { try { this.keepAlive?.pause(); } catch (error) {} } else { this.unlockAudio(); this.sfx('tick'); } return; }
        const level = event.target.closest('[data-level]');
        if (level) { this.setLevel(level.dataset.level); return; }
        if (event.target.closest('[data-skinx-open]')) { this.openSkins(); return; }
        if (event.target.closest('[data-skinx-close]') || event.target === this.p.skinx) { this.closeSkins(); return; }
        const skin = event.target.closest('[data-skin]');
        if (skin) { this.setSkin(skin.dataset.skin); return; }
        if (event.target.closest('[data-copy]')) { this.copyCode(); return; }
        if (event.target.closest('[data-redeem]')) { this.track('reward_redeem', { level: 'extreme' }); return; }
        if (event.target.closest('[data-next]')) { this.nextLevel(); return; }
        if (event.target.closest('[data-who-change]')) { this.showName(); return; }
        if (event.target.closest('[data-name-skip]')) { this.save('nick', ''); this.save('nick-asked', '1'); this.nameForm.hidden = true; this.go(); return; }
        if (event.target.closest('[data-go]')) { if (this.needsName() && !this.load('nick') && this.load('nick-asked') !== '1') { this.showName(); return; } this.go(); return; }
        if (event.target.closest('[data-again]')) { this.reset(); this.go(); return; }
        if (event.target.closest('[data-music]')) { this.musicOn = !this.musicOn; this.save('music', this.musicOn ? '1' : '0'); this.drawMusic(); if (this.musicOn && this.state) this.startMusic(); else this.stopMusic(); return; }
        if (event.target.closest('[data-board-toggle]')) { this.boardOn = !this.boardOn; this.save('board', this.boardOn ? '1' : '0'); this.drawBoard(); return; }
        if (event.target.closest('[data-sky]') && event.detail === 0) this.tapCity(event);
      };
      this.onPointer = event => {
        if (this.kind !== 'city' || this.state !== 'play') return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.cancelable) event.preventDefault();
        this.tapCity(event);
      };
      this.onTouch = event => { if (this.kind === 'city' && (this.state === 'play' || this.state === 'count') && event.cancelable) event.preventDefault(); };
      this.c.arena.addEventListener('pointerdown', this.onPointer);
      this.c.arena.addEventListener('touchstart', this.onTouch, { passive: false });
      this.c.arena.addEventListener('dblclick', this.onTouch);
      this.onClose = () => this.cleanup();
      this.addEventListener('click', this.onClick);
      this.dlg.addEventListener('close', this.onClose);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.querySelector('[data-nick-form]')?.removeEventListener('submit', this.onNick);
      this.nameForm?.removeEventListener('submit', this.onName);
      this.dlg?.removeEventListener('close', this.onClose);
      this.c?.arena?.removeEventListener('pointerdown', this.onPointer);
      this.c?.arena?.removeEventListener('touchstart', this.onTouch);
      this.c?.arena?.removeEventListener('dblclick', this.onTouch);
      this.dlg?.removeEventListener('pointerdown', this.onFlap);
      this.dlg?.removeEventListener('touchstart', this.onFlightTouch);
      this.dlg?.removeEventListener('touchmove', this.onFlightTouch);
      this.dlg?.removeEventListener('dblclick', this.onFlightTouch);
      window.removeEventListener('keydown', this.onKey);
      this.cleanup();
      this.ready = false;
    }
    later(fn, ms) {
      const id = setTimeout(() => { this.timers.delete(id); fn(); }, ms);
      this.timers.add(id);
      return id;
    }
    clearTimers() {
      this.timers.forEach(id => clearTimeout(id));
      this.timers.clear();
      clearInterval(this.ticker);
      clearInterval(this.clockTimer);
      cancelAnimationFrame(this.raf);
      this.relightTimer = null;
    }
    drawSound() {
      this.snd.textContent = this.muted ? (this.t.sound_off || 'OFF') : (this.t.sound_on || 'ON');
      this.snd.setAttribute('aria-pressed', String(!this.muted));
    }
    silentWav() {
      const rate = 8000;
      const n = 4000;
      const bytes = new Uint8Array(44 + n);
      const view = new DataView(bytes.buffer);
      const put = (offset, text) => { for (let i = 0; i < text.length; i += 1) bytes[offset + i] = text.charCodeAt(i); };
      put(0, 'RIFF'); view.setUint32(4, 36 + n, true); put(8, 'WAVE'); put(12, 'fmt ');
      view.setUint32(16, 16, true); view.setUint16(20, 1, true); view.setUint16(22, 1, true);
      view.setUint32(24, rate, true); view.setUint32(28, rate, true); view.setUint16(32, 1, true); view.setUint16(34, 8, true);
      put(36, 'data'); view.setUint32(40, n, true); bytes.fill(128, 44);
      let bin = '';
      bytes.forEach(b => { bin += String.fromCharCode(b); });
      return 'data:audio/wav;base64,' + btoa(bin);
    }
    unlockAudio() {
      if (this.muted) return;
      try { if (navigator.audioSession) navigator.audioSession.type = 'playback'; } catch (error) {}
      try {
        if (!this.keepAlive) {
          this.keepAlive = new Audio(this.silentWav());
          this.keepAlive.loop = true;
          this.keepAlive.setAttribute('playsinline', '');
        }
        const play = this.keepAlive.play();
        if (play && play.catch) play.catch(() => {});
      } catch (error) {}
      const ac = this.audio();
      if (ac && ac.state !== 'running') { try { ac.resume(); } catch (error) {} }
    }
    audio() {
      if (this.muted) return null;
      try {
        const Ctx = window.AudioContext || window.webkitAudioContext;
        if (!Ctx) return null;
        this.ac = this.ac || new Ctx();
        if (this.ac.state === 'suspended') this.ac.resume();
        return this.ac;
      } catch (error) { return null; }
    }
    tone(freq, dur, opts) {
      const ac = this.audio();
      if (!ac) return;
      const o = opts || {};
      const t = ac.currentTime + (o.delay || 0);
      const osc = ac.createOscillator();
      const gain = ac.createGain();
      osc.type = o.type || 'sine';
      osc.frequency.setValueAtTime(freq, t);
      if (o.to) osc.frequency.exponentialRampToValueAtTime(o.to, t + dur);
      gain.gain.setValueAtTime(0.0001, t);
      gain.gain.exponentialRampToValueAtTime(o.vol || 0.1, t + (o.attack || 0.008));
      gain.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      osc.connect(gain);
      gain.connect(ac.destination);
      osc.start(t);
      osc.stop(t + dur + 0.05);
    }
    sfx(name) {
      if (this.muted) return;
      if (name === 'tick') this.tone(660, 0.09, { vol: 0.08 });
      else if (name === 'soft') this.tone(520, 0.12, { vol: 0.04 });
      else if (name === 'go') this.tone(880, 0.25, { vol: 0.1 });
      else if (name === 'off') this.tone(720 + Math.random() * 140, 0.08, { type: 'triangle', to: 300, vol: 0.1 });
      else if (name === 'miss') { this.tone(170, 0.16, { type: 'square', vol: 0.045 }); this.tone(130, 0.22, { type: 'square', vol: 0.045, delay: 0.11 }); }
      else if (name === 'win') [523, 659, 784, 1047].forEach((f, i) => this.tone(f, 0.4, { vol: 0.08, delay: i * 0.12 }));
      else if (name === 'fail') { this.tone(392, 0.25, { type: 'triangle', vol: 0.09 }); this.tone(262, 0.45, { type: 'triangle', vol: 0.09, delay: 0.22 }); }
      else if (name === 'in') this.tone(294, 1.4, { to: 392, vol: 0.045, attack: 0.4 });
      else if (name === 'out') this.tone(392, 1.8, { to: 262, vol: 0.045, attack: 0.4 });
      else if (name === 'flap') this.tone(380, 0.08, { type: 'triangle', to: 600, vol: 0.05 });
      else if (name === 'collect') [988, 1319].forEach((f, i) => this.tone(f, 0.12, { vol: 0.06, delay: i * 0.07 }));
      else if (name === 'calm') [392, 494, 587].forEach((f, i) => this.tone(f, 1.2, { vol: 0.04, attack: 0.2, delay: i * 0.25 }));
    }
    load(key) { try { return localStorage.getItem('axru-' + key); } catch (error) { return null; } }
    save(key, value) { try { localStorage.setItem('axru-' + key, value); } catch (error) {} }
    fmt(seconds) {
      const m = Math.floor(seconds / 60);
      const s = (seconds - m * 60).toFixed(1);
      return m + ':' + (s.length < 4 ? '0' + s : s);
    }
    track(action, extra) {
      const data = Object.assign({ action, game: this.kind, placement: this.dataset.placement }, extra || {});
      try { window.Shopify?.analytics?.publish?.('aurvex_room_interaction', data); } catch (error) {}
      try {
        const pixel = this.dataset.metaPixel;
        if (pixel && typeof window.fbq === 'function') window.fbq('trackSingleCustom', pixel, 'Minigame', data);
      } catch (error) {}
    }
    houses(street, plan, interactive) {
      street.innerHTML = '';
      const windows = [];
      plan.forEach(([cols, rows, width]) => {
        const house = document.createElement('div');
        house.className = 'axru__house';
        house.style.gridTemplateColumns = 'repeat(' + cols + ', 1fr)';
        house.style.width = (cols * width) + '%';
        for (let i = 0; i < cols * rows; i += 1) {
          const win = document.createElement(interactive ? 'button' : 'span');
          win.className = 'axru__win';
          if (interactive) {
            win.type = 'button';
            win.tabIndex = -1;
            win.setAttribute('aria-label', this.t.window || '');
          }
          win._h = windows.length - i;
          win._r = Math.floor(i / cols);
          win._c = i % cols;
          win._cols = cols;
          win._rows = rows;
          win._i = windows.length;
          win._gen = 0;
          house.appendChild(win);
          windows.push(win);
        }
        street.appendChild(house);
      });
      return windows;
    }
    buildPreview() {
      const wins = this.houses(this.querySelector('[data-preview-street]'), [[2, 4, 8.5], [3, 6, 8.5], [2, 5, 8.5], [3, 5, 8.5]], false);
      [1, 2, 5, 9, 10, 13, 16, 18, 22, 27, 31, 34, 38, 41, 44, 47].forEach(i => wins[i]?.classList.add('is-lit'));
    }
    buildStars() {
      const stars = this.querySelector('[data-stars]');
      for (let i = 0; i < 18; i += 1) {
        const star = document.createElement('i');
        star.style.left = (5 + ((i * 37) % 90)) + '%';
        star.style.top = (8 + ((i * 53) % 80)) + '%';
        star.style.animationDelay = (-(i * 0.4)) + 's';
        stars.appendChild(star);
      }
    }

    open(kind) {
      this.kind = kind;
      this.dlg.classList.toggle('is-flight', kind === 'flight');
      this.querySelectorAll('[data-scene]').forEach(scene => { scene.hidden = scene.dataset.scene !== kind; });
      this.querySelector('[data-d-kicker]').textContent = this.kickers[kind];
      this.reset();
      if (typeof this.dlg.showModal === 'function') { if (!this.dlg.open) this.dlg.showModal(); }
      else this.dlg.setAttribute('open', '');
      document.documentElement.classList.add('axru-lock');
      this.dlg.scrollTop = 0;
      this.unlockAudio();
      this.track('open');
      requestAnimationFrame(() => this.p.go.focus({ preventScroll: true }));
    }
    close() {
      if (typeof this.dlg.close === 'function' && this.dlg.open) this.dlg.close();
      else this.dlg.removeAttribute('open');
      this.cleanup();
    }
    cleanup() {
      try { this.keepAlive?.pause(); } catch (error) {}
      this.stopMusic();
      this.clearTimers();
      this.state = null;
      document.documentElement.classList.remove('axru-lock');
    }
    setState(state) {
      this.state = state;
      this.dlg.classList.toggle('is-intro', state === 'intro');
      this.dlg.classList.toggle('is-play', state === 'play' || state === 'count');
      this.dlg.classList.toggle('is-count', state === 'count');
      this.dlg.classList.toggle('is-end', state === 'end');
    }
    record(level) {
      const value = parseFloat(String(this.dataset['record' + level.charAt(0).toUpperCase() + level.slice(1)] || '').replace(',', '.'));
      return value > 0 ? value : null;
    }
    best(level) {
      const value = parseFloat(this.load('best-' + level));
      return value > 0 ? value : null;
    }
    statsLine(level) {
      const best = this.best(level);
      const record = this.record(level);
      let line = (this.t.best || '') + ': <b>' + (best ? this.fmt(best) : (this.t.none || '')) + '</b>';
      if (record) line += ' · ' + (this.t.record || '') + ': <b>' + this.fmt(record) + '</b>' + (this.dataset.recordName ? ' (' + this.escape(this.dataset.recordName) + ')' : '');
      if (level === 'extreme' && this.monthCode()) line += '<br>' + this.escape(this.fill(this.t.reward_hint));
      return line;
    }
    fill(text) {
      const end = new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0);
      let endText = '';
      try { endText = end.toLocaleDateString(document.documentElement.lang || undefined, { day: 'numeric', month: 'long' }); } catch (error) { endText = end.getDate() + '.' + (end.getMonth() + 1) + '.'; }
      return (text || '').replace('{pct}', this.dataset.pct).replace('{sec}', this.dataset.sec).replace('{end}', endText).replace('{n}', this.lives).replace('{fmin}', this.dataset.fmin);
    }
    monthCode() {
      let list = '';
      try { list = atob(this.dataset.reward || ''); } catch (error) { return ''; }
      const now = new Date();
      const key = now.getFullYear() + '-' + String(now.getMonth() + 1).padStart(2, '0');
      const line = list.split(/\r?\n/).map(row => row.trim().split(/[\s=;]+/)).find(parts => parts[0] === key && parts[1]);
      return line ? line[1] : '';
    }
    escape(text) { const span = document.createElement('span'); span.textContent = text; return span.innerHTML; }
    setLevel(level) {
      if (!this.constructor.LEVELS[level] || this.state !== 'intro') return;
      this.level = level;
      this.save('level', level);
      this.querySelectorAll('[data-level]').forEach(button => button.setAttribute('aria-checked', String(button.dataset.level === level)));
      this.p.stats.innerHTML = this.statsLine(level);
      this.buildCity();
    }
    panel(mode, message, statsHtml) {
      const intro = mode === 'intro';
      const city = this.kind === 'city';
      const flight = this.kind === 'flight';
      this.p.kicker.textContent = intro ? this.t.how : this.titles[this.kind];
      this.p.purpose.textContent = intro ? this.purposes[this.kind] : '';
      this.p.purpose.hidden = !intro;
      this.p.title.textContent = intro ? this.titles[this.kind] : message;
      this.p.steps.innerHTML = '';
      if (intro) (this.t[city ? 'c_steps' : flight ? 'f_steps' : 'b_steps'] || []).forEach(text => {
        const li = document.createElement('li');
        li.textContent = text;
        this.p.steps.appendChild(li);
      });
      this.p.steps.hidden = !intro;
      this.p.levels.hidden = !(intro && city);
      if (this.p.skincur && intro && flight) this.buildSkins();
      if (this.p.skincur) this.p.skincur.hidden = !(intro && flight);
      this.querySelectorAll('[data-level]').forEach(button => button.setAttribute('aria-checked', String(button.dataset.level === this.level)));
      this.p.stats.hidden = !(city || flight);
      const unlock = this.querySelector('[data-unlock]');
      if (unlock) unlock.hidden = true;
      if (city) this.p.stats.innerHTML = intro ? this.statsLine(this.level) : (statsHtml || '');
      if (flight) this.p.stats.innerHTML = intro ? this.flightStats() : (statsHtml || '');
      this.p.reward.hidden = true;
      this.p.go.hidden = !intro;
      this.p.again.hidden = intro;
      this.p.next.hidden = true;
      this.p.again.classList.add('axru__play', 'axru__play--light');
      this.p.again.classList.remove('axru__link');
      if (this.p.cta) this.p.cta.hidden = intro;
      this.p.board.hidden = true;
      if (this.nameForm) this.nameForm.hidden = true;
      if (this.who) this.drawWho(intro);
      if (this.p.spotify) this.p.spotify.hidden = intro || !this.dataset.bgm;
      this.p.back.hidden = intro;
    }
    reset() {
      this.clearTimers();
      this.dlg.classList.remove('is-asleep');
      this.setState('intro');
      this.panel('intro');
      if (this.kind === 'breathe') {
        this.b.orb.style.transitionDuration = '1.2s';
        this.b.orb.classList.remove('is-full');
        this.b.phase.textContent = '';
        this.b.count.textContent = '';
        this.b.dots.forEach(dot => dot.classList.remove('is-done'));
      } else if (this.kind === 'flight') {
        this.buildFlight();
      } else {
        this.buildCity();
      }
    }
    go() {
      this.unlockAudio();
      this.startMusic();
      this.track('start', this.kind === 'city' ? { level: this.level } : {});
      if (this.kind === 'breathe') { this.setState('play'); this.startBreathe(); return; }
      this.setState('count');
      let left = 3;
      const cd = this.kind === 'flight' ? this.fl.cd : this.c.cd;
      const show = value => {
        cd.textContent = value;
        cd.classList.remove('is-on');
        void cd.offsetWidth;
        cd.classList.add('is-on');
      };
      show(left);
      this.sfx('tick');
      clearInterval(this.ticker);
      this.ticker = setInterval(() => {
        left -= 1;
        if (left > 0) { show(left); this.sfx('tick'); return; }
        clearInterval(this.ticker);
        cd.classList.remove('is-on');
        cd.textContent = '';
        this.sfx('go');
        this.setState('play');
        if (this.kind === 'flight') { this.startFlight(); return; }
        this.t0 = performance.now();
        this.c.clock.textContent = this.fmt(0);
        this.clockTimer = setInterval(() => { this.c.clock.textContent = this.fmt((performance.now() - this.t0) / 1000); }, 100);
        this.scheduleRelight();
        this.windows.find(win => win.classList.contains('is-lit'))?.focus({ preventScroll: true });
      }, 1000);
    }
    nextLevel() {
      const next = { easy: 'medium', medium: 'extreme' }[this.level];
      if (!next) return;
      this.level = next;
      this.save('level', next);
      this.track('next_level', { level: next });
      this.reset();
      requestAnimationFrame(() => this.p.go.focus({ preventScroll: true }));
    }
    finish(message, statsHtml) {
      this.setState('end');
      this.panel('end', message, statsHtml);
      requestAnimationFrame(() => this.p.again.focus({ preventScroll: true }));
    }
    sleepMode() {
      this.track('sleep_cta');
      this.close();
      const button = document.querySelector('ax-night-sounds [data-card="sleep"] .axns__play');
      if (button) { button.click(); return; }
      const link = document.querySelector('ax-night-sounds [data-card="sleep"] [data-out="spotify"]');
      if (link) { window.open(link.href, '_blank', 'noopener'); return; }
      if (this.dataset.sounds) window.location.href = this.dataset.sounds;
    }
    drawMusic() {
      if (!this.musicBtn) return;
      this.musicBtn.textContent = this.musicOn ? (this.t.music_on || 'ON') : (this.t.music_off || 'OFF');
      this.musicBtn.setAttribute('aria-pressed', String(this.musicOn));
    }
    startMusic() {
      const src = this.dataset.bgm;
      if (!src || !this.musicOn) return;
      try {
        if (!this.bgm) {
          const volume = Math.min(1, Math.max(0, (parseFloat(this.dataset.bgmVol) || 25) / 100));
          this.bgm = new Audio();
          if (!/^(data|blob):/.test(src)) this.bgm.crossOrigin = 'anonymous';
          this.bgm.src = src;
          this.bgm.loop = true;
          this.bgm.preload = 'auto';
          this.bgm.setAttribute('playsinline', '');
          this.bgm.volume = volume;
          const ac = this.audio();
          if (ac && ac.createMediaElementSource) {
            try {
              const node = ac.createMediaElementSource(this.bgm);
              this.bgmGain = ac.createGain();
              this.bgmGain.gain.value = volume;
              this.bgm.volume = 1;
              node.connect(this.bgmGain);
              this.bgmGain.connect(ac.destination);
            } catch (error) { this.bgm.volume = volume; }
          }
        }
        const play = this.bgm.play();
        if (play && play.catch) play.catch(() => {});
        this.track('music_start');
      } catch (error) {}
    }
    stopMusic() {
      try { this.bgm?.pause(); } catch (error) {}
    }
    drawBoard() {
      if (!this.boardBtn) return;
      this.boardBtn.textContent = this.boardOn ? (this.t.board_on || 'ON') : (this.t.board_off || 'OFF');
      this.boardBtn.setAttribute('aria-pressed', String(this.boardOn));
    }
    cityBody(seconds) {
      const gaps = this.gaps || [];
      return { level: this.level, ms: Math.round(seconds * 1000), taps: this.taps, litTotal: this.litTotal, misses: this.misses, relights: this.relights, minGap: gaps.length ? Math.round(Math.min(...gaps)) : 999, avgGap: gaps.length ? Math.round(gaps.reduce((a, b) => a + b, 0) / gaps.length) : 999 };
    }
    async submitRun(body) {
      if (!this.dataset.board || !this.boardOn) return;
      const box = this.p.board;
      const note = this.querySelector('[data-board-note]');
      this.runLevel = body.level;
      let nick = this.load('nick');
      if (nick) body.name = nick;
      body.dev = this.deviceId();
      this.runId = null;
      try {
        const url = this.dataset.board.replace(/\/$/, '') + '/run';
        const post = () => fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
        let res = await post();
        let data = await res.json().catch(() => ({}));
        let rejected = false;
        if (res.status === 422 && data.error === 'name' && body.name) {
          delete body.name; nick = ''; this.save('nick', ''); rejected = true;
          res = await post();
          data = await res.json().catch(() => ({}));
        }
        if (!res.ok || this.state !== 'end') { if (this.state === 'end' && res.status !== 429) { note.textContent = this.t.board_err || ''; box.hidden = false; } return; }
        this.runId = data.id;
        this.runToken = data.token;
        this.remember(data.id, data.token, body.level);
        this.querySelector('[data-board-rank]').textContent = ((data.totalAll > 1 ? this.t.rank : this.t.rank1) || '').replace('{all}', data.rankAll).replace('{pct}', data.betterThan);
        this.querySelector('[data-board-pct]').textContent = '';
        this.querySelector('[data-nick-form]').hidden = true;
        note.textContent = rejected ? (this.t.name_rejected || '') : '';
        box.hidden = false;
        this.track('board_rank', { level: body.level, rank_day: data.rankDay, rank_all: data.rankAll });
        window.dispatchEvent(new CustomEvent('axlb:refresh', { detail: { level: body.level } }));
      } catch (error) {
        if (this.state === 'end') { note.textContent = this.t.board_err || ''; box.hidden = false; }
      }
    }
    needsName() {
      return !!this.dataset.board && this.boardOn !== false && (this.kind === 'city' || this.kind === 'flight');
    }
    drawWho(intro) {
      const nick = this.load('nick');
      const show = intro && this.needsName() && (!!nick || this.load('nick-asked') === '1');
      this.who.hidden = !show;
      if (!show) return;
      this.querySelector('[data-who-text]').textContent = nick ? (this.t.playing || '').replace('{name}', nick) : (this.t.playing_anon || '');
      this.querySelector('[data-who-change]').textContent = nick ? (this.t.change || '') : (this.t.add_name || '');
    }
    showName() {
      if (this.state !== 'intro') return;
      this.p.kicker.textContent = this.titles[this.kind] || '';
      this.p.title.textContent = this.t.name_title || '';
      [this.p.purpose, this.p.steps, this.p.levels, this.p.stats, this.p.go, this.who].forEach(el => { if (el) el.hidden = true; });
      this.querySelector('[data-name-bad]').textContent = '';
      this.nameInput.value = this.load('nick') || '';
      this.nameForm.hidden = false;
      requestAnimationFrame(() => this.nameInput.focus({ preventScroll: true }));
    }
    submitName() {
      const name = String(this.nameInput.value || '').replace(/\s+/g, ' ').trim().toUpperCase();
      if (!/^[A-Za-z0-9ÄÖÜäöüßÀ-ÿ _.\-]{2,16}$/.test(name)) { this.querySelector('[data-name-bad]').textContent = this.t.nick_bad || ''; return; }
      if ((this.load('nick') || '') !== name) this.renameRuns(name);
      this.save('nick', name);
      this.save('nick-asked', '1');
      this.nameInput.blur();
      this.nameForm.hidden = true;
      this.go();
    }
    deviceId() {
      // Zufaellige Geraete-Kennung: ein Spieler pro Geraet in der Bestenliste (Server speichert nur einen Hash).
      let id = this.load('dev');
      if (!/^[a-f0-9]{32}$/.test(id || '')) {
        const bytes = new Uint8Array(16);
        crypto.getRandomValues(bytes);
        id = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
        this.save('dev', id);
      }
      return id;
    }
    renameRuns(name) {
      let runs = [];
      try { runs = JSON.parse(this.load('runs') || '[]'); } catch (error) {}
      if (!this.dataset.board || !Array.isArray(runs) || !runs.length) return;
      fetch(this.dataset.board.replace(/\/$/, '') + '/rename', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ name, runs: runs.map(run => ({ id: run.id, token: run.token })) }) })
        .then(() => window.dispatchEvent(new CustomEvent('axlb:refresh')))
        .catch(() => {});
    }
    remember(id, token, level) {
      if (!id || !token) return;
      let runs = [];
      try { runs = JSON.parse(this.load('runs') || '[]'); } catch (error) {}
      if (!Array.isArray(runs)) runs = [];
      runs.unshift({ id, token, level, ts: Date.now() });
      this.save('runs', JSON.stringify(runs.slice(0, 40)));
    }
    async saveNick() {
      const input = this.querySelector('[data-nick-input]');
      const note = this.querySelector('[data-board-note]');
      const name = String(input.value || '').replace(/\s+/g, ' ').trim();
      if (!this.runId || !/^[A-Za-z0-9ÄÖÜäöüßÀ-ÿ _.\-]{2,16}$/.test(name)) { note.textContent = this.t.nick_bad || ''; return; }
      try {
        const res = await fetch(this.dataset.board.replace(/\/$/, '') + '/run/' + this.runId, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token: this.runToken, name }) });
        if (!res.ok) { note.textContent = this.t.nick_bad || ''; return; }
        this.save('nick', name);
        this.querySelector('[data-nick-form]').hidden = true;
        note.textContent = '';
        window.dispatchEvent(new CustomEvent('axlb:refresh', { detail: { level: this.runLevel } }));
      } catch (error) { note.textContent = this.t.board_err || ''; }
    }
    copyCode() {
      const code = this.querySelector('[data-code]').textContent;
      const button = this.querySelector('[data-copy]');
      const done = () => { button.textContent = this.t.copied || ''; this.later(() => { button.textContent = this.t.copy || ''; }, 2000); };
      try { navigator.clipboard.writeText(code).then(done, done); } catch (error) { done(); }
      this.track('reward_copy', { level: 'extreme' });
    }

    startBreathe() {
      this.rounds = 1;
      this.b.phase.textContent = this.t.ready;
      let left = 3;
      this.b.count.textContent = left;
      this.sfx('soft');
      clearInterval(this.ticker);
      this.ticker = setInterval(() => { left -= 1; this.b.count.textContent = left > 0 ? left : ''; if (left > 0) this.sfx('soft'); }, 1000);
      this.later(() => this.breathePhase('in'), 3000);
    }
    breathePhase(phase) {
      if (this.state !== 'play') return;
      const seconds = phase === 'in' ? 4 : 6;
      this.b.orb.style.transitionDuration = seconds + 's';
      this.b.orb.classList.toggle('is-full', phase === 'in');
      this.b.phase.textContent = this.t[phase];
      this.sfx(phase);
      let left = seconds;
      this.b.count.textContent = left;
      clearInterval(this.ticker);
      this.ticker = setInterval(() => { left -= 1; this.b.count.textContent = left > 0 ? left : ''; }, 1000);
      this.later(() => {
        if (phase === 'in') { this.breathePhase('out'); return; }
        this.b.dots[this.rounds - 1]?.classList.add('is-done');
        if (this.rounds < 5) { this.rounds += 1; this.breathePhase('in'); return; }
        clearInterval(this.ticker);
        this.b.phase.textContent = '';
        this.b.count.textContent = '';
        this.b.orb.style.transitionDuration = '2s';
        this.track('done');
        this.sfx('calm');
        this.finish(this.t.done_b);
      }, seconds * 1000);
    }

    buildCity() {
      const config = this.constructor.LEVELS[this.level];
      this.windows = this.houses(this.c.street, config.plan, true);
      this.relights = 0;
      this.taps = 0;
      this.misses = 0;
      this.gaps = [];
      this.lastTap = 0;
      this.litTotal = config.lit;
      this.lives = this.constructor.LIVES;
      this.drawLives();
      this.dlg.classList.remove('is-over');
      this.c.toast.classList.remove('is-on');
      this.c.cd.classList.remove('is-on');
      this.c.cd.textContent = '';
      this.c.clock.textContent = this.fmt(0);
      const pool = this.windows.slice().sort(() => Math.random() - 0.5);
      pool.slice(0, config.lit).forEach(win => this.setLit(win, true));
      this.updateLit();
    }
    drawLives() {
      this.c.lives.innerHTML = '';
      this.c.lives.setAttribute('aria-label', (this.t.lives || '') + ': ' + this.lives);
      for (let i = 0; i < this.constructor.LIVES; i += 1) {
        const dot = document.createElement('i');
        if (i >= this.lives) dot.className = 'is-lost';
        this.c.lives.appendChild(dot);
      }
    }
    litNear(x, y, pad) {
      return this.litWindows().find(win => {
        const box = win.getBoundingClientRect();
        return x >= box.left - pad && x <= box.right + pad && y >= box.top - pad && y <= box.bottom + pad;
      });
    }
    miss(win) {
      this.sfx('miss');
      this.misses = (this.misses || 0) + 1;
      this.lives -= 1;
      this.drawLives();
      win.classList.remove('is-miss');
      void win.offsetWidth;
      win.classList.add('is-miss');
      this.c.arena.classList.remove('is-hurt');
      void this.c.arena.offsetWidth;
      this.c.arena.classList.add('is-hurt');
      try { navigator.vibrate?.(60); } catch (error) {}
      if (this.lives <= 0) { this.cityFail(); return; }
      const penalty = this.constructor.LEVELS[this.level].penalty || 0;
      if (penalty && this.t0) this.t0 -= penalty * 1000;
      this.c.toast.textContent = this.fill(this.lives === 1 ? this.t.miss1 : this.t.miss) + (penalty ? ' ' + (this.t.penalty || '').replace('{s}', penalty) : '');
      this.c.toast.classList.add('is-on');
      this.later(() => this.c.toast.classList.remove('is-on'), 1400);
    }
    cityFail() {
      const seconds = Math.round((performance.now() - this.t0) / 100) / 10;
      this.clearTimers();
      this.c.toast.classList.remove('is-on');
      this.dlg.classList.add('is-over');
      this.later(() => this.sfx('fail'), 250);
      this.track('fail', { level: this.level, seconds });
      const stats = ((this.t.levels || {})[this.level] || this.level) + ' · ' + (this.t.time || '') + ': ' + this.fmt(seconds) + '<br><b>' + this.escape(this.t.over_note || '') + '</b>';
      this.later(() => this.finish(this.t.over, stats), 900);
    }
    setLit(win, on) {
      win.classList.toggle('is-lit', on);
      win.classList.remove('is-new');
      win._gen = (win._gen || 0) + 1;
      win.tabIndex = on ? 0 : -1;
      win.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
    litWindows() { return this.windows.filter(win => win.classList.contains('is-lit')); }
    updateLit() {
      const n = this.litWindows().length;
      this.c.lit.textContent = n + ' ' + (n === 1 ? this.t.on1 : this.t.onN);
      return n;
    }
    scheduleRelight() {
      const config = this.constructor.LEVELS[this.level];
      if (this.relightTimer || this.relights >= config.relights || this.state !== 'play') return;
      const elapsed = this.t0 ? (performance.now() - this.t0) / 1000 : 0;
      const speed = 1 - Math.min(config.ramp || 0, elapsed / 40);
      const wait = (config.every[0] + Math.random() * (config.every[1] - config.every[0])) * speed;
      this.relightTimer = this.later(() => {
        this.relightTimer = null;
        if (this.state !== 'play') return;
        const n = this.litWindows().length;
        if (n <= config.min) return;
        const dark = this.windows.filter(win => !win.classList.contains('is-lit'));
        const win = dark[Math.floor(Math.random() * dark.length)];
        if (!win) return;
        this.relights += 1;
        this.lightUp(win);
        if (config.double && Math.random() < config.double) {
          const more = this.windows.filter(item => !item.classList.contains('is-lit'));
          const second = more[Math.floor(Math.random() * more.length)];
          if (second) this.lightUp(second);
        }
        this.updateLit();
        if (this.relights <= 2 || this.relights % 5 === 0) {
          this.c.toast.textContent = this.t.relight;
          this.c.toast.classList.add('is-on');
          this.later(() => this.c.toast.classList.remove('is-on'), 1800);
        }
        this.scheduleRelight();
      }, wait);
    }
    flightStats() {
      const best = parseInt(this.load('best-flight'), 10) || 0;
      let line = (this.t.best || '') + ': <b>' + (best ? best + ' ' + (this.t.points || '') : (this.t.none || '')) + '</b>';
      if (this.monthCode()) line += '<br>' + this.escape(this.fill(this.t.f_hint));
      return line;
    }
    buildFlight() {
      const C = this.constructor.FLIGHT;
      cancelAnimationFrame(this.raf);
      this.f = { y: 200, vy: 0, t: 0, dist: 0, zs: 0, flaps: 0, cols: [], nextCol: C.first, crows: [], nextCrow: C.crowFrom, alive: true, acc: 0, last: 0, wing: 0 };
      this.dlg.classList.remove('is-over');
      this.fl.cd.classList.remove('is-on');
      this.fl.cd.textContent = '';
      this.fl.score.textContent = '0 ' + (this.t.points || '');
      this.fl.zs.textContent = 'Z 0';
      this.sizeFlight();
      this.drawFlight();
    }
    sizeFlight() {
      const canvas = this.fl.canvas;
      const box = canvas.getBoundingClientRect();
      const dpr = Math.min(2, window.devicePixelRatio || 1);
      const size = Math.max(240, Math.round((box.width || 400) * dpr));
      if (canvas.width !== size) { canvas.width = size; canvas.height = size; }
      this.fctx = canvas.getContext('2d');
      this.fctx.setTransform(size / 400, 0, 0, size / 400, 0, 0);
      if (!this.fStars) {
        let seed = 7;
        const rnd = () => { seed = (seed * 16807) % 2147483647; return seed / 2147483647; };
        this.fStars = Array.from({ length: 34 }, (_, i) => ({ x: Math.floor(rnd() * 400), y: 10 + Math.floor(rnd() * 220), s: i % 4 === 0 ? 2 : 1 }));
      }
      this.ffont = (getComputedStyle(this).getPropertyValue('--ax-mono') || '').trim() || 'monospace';
    }
    startFlight() {
      this.sizeFlight();
      this.f.last = performance.now();
      this.flap();
      this.raf = requestAnimationFrame(now => this.flightLoop(now));
    }
    flap() {
      if (!this.f || !this.f.alive) return;
      this.f.vy = this.constructor.FLIGHT.flap;
      this.f.flaps += 1;
      this.f.wing = 0.18;
      this.sfx('flap');
    }
    flightLoop(now) {
      if (this.state !== 'play' || this.kind !== 'flight') return;
      const f = this.f;
      const dt = 1 / 120;
      f.acc += Math.min(0.1, Math.max(0, (now - f.last) / 1000));
      f.last = now;
      while (f.acc >= dt && f.alive) { this.flightStep(dt); f.acc -= dt; }
      this.drawFlight();
      this.fl.score.textContent = this.flightScore() + ' ' + (this.t.points || '');
      this.fl.zs.textContent = 'Z ' + f.zs;
      if (!f.alive) { this.flightOver(); return; }
      this.raf = requestAnimationFrame(next => this.flightLoop(next));
    }
    flightStep(dt) {
      const C = this.constructor.FLIGHT;
      const f = this.f;
      // Tempo und Luecke aendern sich weich (Exponentialkurve, kein Knick); identisch im Worker.
      const v = C.vMax - (C.vMax - C.v0) * Math.exp(-f.t / C.tau);
      const gap = C.gapMin + (C.gap0 - C.gapMin) * Math.exp(-f.t / C.gapTau);
      while (f.nextCol - f.dist < C.look) {
        const c = 70 + gap / 2 + Math.random() * (C.ground - 110 - gap);
        f.cols.push({ x: f.nextCol, c, gap, z: Math.random() < C.zChance, zy: c + (Math.random() * 2 - 1) * gap * 0.25, sign: C.signs[Math.floor(Math.random() * C.signs.length)], seed: Math.floor(Math.random() * 1000) });
        f.nextCol += C.spacing;
      }
      if (f.t >= f.nextCrow) {
        // Kraehe startet immer rechts ausserhalb des Bildes und erreicht den Spieler genau
        // in der Mitte zwischen zwei Haeusern, mit Abstand zur Linie zwischen den Luecken.
        for (let i = 0; i < f.cols.length - 1; i += 1) {
          const col = f.cols[i];
          const x0 = ((col.x - f.dist + (C.w + C.spacing) / 2) * (v + C.crowSpeed) - C.x * C.crowSpeed) / v;
          if (x0 < 430) continue;
          const mid = (col.c + f.cols[i + 1].c) / 2;
          const d = C.crowD[0] + Math.random() * (C.crowD[1] - C.crowD[0]);
          const okUp = mid - d >= 70;
          const okDown = mid + d <= C.ground - 60;
          const y = okUp && okDown ? (Math.random() < 0.5 ? mid - d : mid + d) : (okUp ? mid - d : mid + d);
          f.crows.push({ x: x0 + f.dist, y });
          break;
        }
        f.nextCrow = f.t + C.crowEvery[0] + Math.random() * (C.crowEvery[1] - C.crowEvery[0]);
      }
      f.vy = Math.min(C.vmax, f.vy + C.g * dt);
      f.y += f.vy * dt;
      f.t += dt;
      f.dist += v * dt;
      f.wing = Math.max(0, f.wing - dt);
      f.crows.forEach(crow => { crow.x -= C.crowSpeed * dt; });
      if (f.y < C.ph / 2) { f.y = C.ph / 2; f.vy = 0; }
      if (f.y + C.ph / 2 >= C.ground) { f.alive = false; return; }
      for (const col of f.cols) {
        const sx = col.x - f.dist;
        if (sx < C.x + C.pw / 2 - 3 && sx + C.w > C.x - C.pw / 2 + 3 && (f.y - C.ph / 2 + 2 < col.c - col.gap / 2 || f.y + C.ph / 2 - 2 > col.c + col.gap / 2)) { f.alive = false; return; }
        if (col.z && Math.abs(sx + C.w / 2 - C.x) < 16 && Math.abs(col.zy - f.y) < 18) { col.z = false; f.zs += 1; this.sfx('collect'); }
      }
      for (const crow of f.crows) {
        if (Math.abs(crow.x - f.dist - C.x) < 20 && Math.abs(crow.y - f.y) < 15) { f.alive = false; return; }
      }
      f.cols = f.cols.filter(col => col.x - f.dist > -80);
      f.crows = f.crows.filter(crow => crow.x - f.dist > -40);
    }
    flightScore() { return Math.floor(this.f.dist / 10) + this.f.zs * 10; }
    drawFlight() {
      const ctx = this.fctx;
      const f = this.f;
      if (!ctx || !f) return;
      const C = this.constructor.FLIGHT;
      const font = this.ffont;
      const sky = ctx.createLinearGradient(0, 0, 0, C.ground);
      sky.addColorStop(0, '#0B0A08');
      sky.addColorStop(1, '#221E17');
      ctx.fillStyle = sky;
      ctx.fillRect(0, 0, 400, 400);
      ctx.fillStyle = '#F6F2EA';
      this.fStars.forEach((star, i) => {
        const x = ((star.x - f.dist * 0.04) % 400 + 400) % 400;
        ctx.globalAlpha = 0.3 + 0.5 * Math.abs(Math.sin(f.t * 1.3 + i));
        ctx.fillRect(Math.round(x), star.y, star.s, star.s);
      });
      ctx.globalAlpha = 1;
      ctx.beginPath(); ctx.arc(338, 58, 15, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#0E0C0A';
      ctx.beginPath(); ctx.arc(331, 54, 14, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#17150F';
      const step = 34;
      const far = f.dist * 0.25;
      for (let i = -1; i < 14; i += 1) {
        const n = Math.floor(far / step) + i;
        const h = 40 + (((n * 47) % 70) + 70) % 70;
        ctx.fillRect(Math.round(i * step - (far % step)), C.ground - h, 30, h);
      }
      f.cols.forEach(col => {
        const sx = Math.round(col.x - f.dist);
        if (sx > 410 || sx < -C.w - 10) return;
        const top = Math.round(col.c - col.gap / 2);
        const bot = Math.round(col.c + col.gap / 2);
        ctx.fillStyle = '#2B2720';
        ctx.fillRect(sx, bot, C.w, C.ground - bot);
        ctx.fillStyle = '#3A352C';
        ctx.fillRect(sx - 3, bot, C.w + 6, 5);
        let j = 0;
        for (let wy = bot + 12; wy < C.ground - 10; wy += 16) {
          let i = 0;
          for (let wx = sx + 7; wx < sx + C.w - 8; wx += 14) {
            ctx.fillStyle = ((i * 7 + j * 13 + col.seed) % 5) === 0 ? '#E8B97A' : '#141210';
            ctx.fillRect(wx, wy, 7, 9);
            i += 1;
          }
          j += 1;
        }
        ctx.fillStyle = f.t % 1 < 0.5 ? '#D0564F' : '#5A2A2A';
        ctx.fillRect(sx + C.w - 9, bot + 7, 3, 3);
        ctx.fillStyle = '#1E1B16';
        ctx.fillRect(sx, 0, C.w, top);
        ctx.fillStyle = '#C87E96';
        ctx.fillRect(sx, top - 3, C.w, 3);
        ctx.fillRect(sx, 0, 2, top);
        ctx.fillRect(sx + C.w - 2, 0, 2, top);
        ctx.save();
        ctx.font = '12px ' + font;
        ctx.textAlign = 'center';
        ctx.textBaseline = 'alphabetic';
        ctx.fillStyle = '#F2B8CB';
        ctx.shadowColor = '#C87E96';
        ctx.shadowBlur = 8;
        if (top > 18) ctx.fillText(col.sign, sx + C.w / 2, top - 8);
        ctx.restore();
        if (col.z) {
          ctx.save();
          ctx.font = '20px ' + font;
          ctx.textAlign = 'center';
          ctx.textBaseline = 'middle';
          ctx.fillStyle = '#E8B97A';
          ctx.shadowColor = '#E8B97A';
          ctx.shadowBlur = 10;
          ctx.fillText('Z', sx + C.w / 2, col.zy + Math.sin(f.t * 4 + col.seed) * 3);
          ctx.restore();
        }
      });
      f.crows.forEach(crow => {
        const cx = Math.round(crow.x - f.dist);
        const cy = Math.round(crow.y);
        ctx.fillStyle = '#C4BCB2';
        ctx.fillRect(cx - 9, cy - 3, 18, 7);
        ctx.fillRect(cx - 13, cy - 1, 4, 3);
        ctx.fillStyle = '#0A0908';
        ctx.fillRect(cx - 8, cy - 2, 16, 5);
        ctx.fillStyle = '#C4BCB2';
        if (Math.sin(f.t * 14) > 0) ctx.fillRect(cx - 4, cy - 9, 9, 6); else ctx.fillRect(cx - 4, cy + 4, 9, 5);
        ctx.fillStyle = '#E8B97A';
        ctx.fillRect(cx - 10, cy - 1, 2, 2);
      });
      ctx.fillStyle = '#1A1712';
      ctx.fillRect(0, C.ground, 400, 400 - C.ground);
      ctx.fillStyle = '#3A352C';
      ctx.fillRect(0, C.ground, 400, 2);
      ctx.save();
      ctx.translate(C.x, Math.round(f.y));
      ctx.rotate(Math.max(-0.45, Math.min(0.6, f.vy / 900)));
      this.drawSkin(ctx, this.skin, f.t, f.wing);
      ctx.globalAlpha = 1;
      ctx.restore();
      ctx.font = '22px ' + font;
      ctx.textAlign = 'left';
      ctx.textBaseline = 'top';
      ctx.fillStyle = '#F6F2EA';
      ctx.fillText(String(this.flightScore()), 12, 10);
    }
    static SKINS = ['mask', 'sheep', 'moon', 'sun', 'comet', 'meteor'];
    // Freischaltung ueber den persoenlichen Bestwert (Punkte in einer Runde). Rein optisch.
    static TIERS = {
      mask: { min: 0, r: 'STANDARD', c: '#C4BCB2' },
      sheep: { min: 500, r: 'COMMON', c: '#A8A29A' },
      moon: { min: 1000, r: 'UNCOMMON', c: '#6FBF73' },
      sun: { min: 1500, r: 'RARE', c: '#5EA2F0' },
      comet: { min: 2000, r: 'EPIC', c: '#B07CF0' },
      meteor: { min: 3000, r: 'LEGENDARY', c: '#E8B97A' }
    };
    flightBest() { return parseInt(this.load('best-flight'), 10) || 0; }
    skinOpen(skin) { const tier = this.constructor.TIERS[skin]; return !!tier && this.flightBest() >= tier.min; }
    num(n) { try { return Number(n).toLocaleString(document.documentElement.lang || undefined); } catch (error) { return String(n); } }
    skinPreview(canvas, skin, open, clear) {
      const ctx = canvas.getContext('2d');
      const w = canvas.width, h = canvas.height, k = w / 84;
      ctx.clearRect(0, 0, w, h);
      if (!clear) { ctx.fillStyle = '#0E0D0B'; ctx.fillRect(0, 0, w, h); }
      ctx.save();
      ctx.translate((skin === 'comet' || skin === 'meteor' ? 54 : 42) * k, 28 * k);
      ctx.scale(1.25 * k, 1.25 * k);
      this.drawSkin(ctx, skin, 0.3, 0.15);
      ctx.restore();
      ctx.globalAlpha = 1;
      if (open) return;
      if (!clear) { ctx.fillStyle = 'rgba(14,13,11,.55)'; ctx.fillRect(0, 0, w, h); }
      const s = Math.max(1, Math.round(2 * k)), x = Math.round(w / 2 - 4 * s), y = Math.round(h / 2 - 4 * s);
      ctx.fillStyle = '#F6F2EA';
      ctx.fillRect(x + s, y, 6 * s, s); ctx.fillRect(x + s, y, s, 3 * s); ctx.fillRect(x + 6 * s, y, s, 3 * s);
      ctx.fillRect(x, y + 3 * s, 8 * s, 6 * s);
      ctx.fillStyle = '#0E0D0B';
      ctx.fillRect(x + 3 * s, y + 5 * s, 2 * s, 2 * s);
    }
    skinRow(box) {
      if (!box) return;
      const names = this.t.skins || {};
      const best = this.flightBest();
      box.innerHTML = '';
      this.constructor.SKINS.forEach((skin, index) => {
        const tier = this.constructor.TIERS[skin];
        const open = best >= tier.min;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'axru__skin' + (open ? '' : ' is-locked') + (open && index >= 3 ? ' is-glow' : '') + (skin === 'mask' ? ' is-base' : '');
        button.dataset.skin = skin;
        button.style.setProperty('--rar', tier.c);
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', String(open && skin === this.skin));
        if (!open) button.setAttribute('aria-disabled', 'true');
        const art = document.createElement('span');
        art.className = 'axru__skin-art';
        const canvas = document.createElement('canvas');
        canvas.width = 168;
        canvas.height = 112;
        canvas.setAttribute('aria-hidden', 'true');
        art.appendChild(canvas);
        const ok = document.createElement('span');
        ok.className = 'axru__skin-ok';
        ok.setAttribute('aria-hidden', 'true');
        ok.textContent = '✓';
        const label = document.createElement('span');
        label.className = 'axru__skin-n';
        label.textContent = names[skin] || skin.toUpperCase();
        const rar = document.createElement('small');
        rar.className = 'axru__skin-r';
        rar.textContent = open ? tier.r : (this.t.skin_from || 'ab {n}').replace('{n}', this.num(tier.min)).toUpperCase();
        button.append(ok, art, label, rar);
        if (!open) {
          const bar = document.createElement('span');
          bar.className = 'axru__skin-bar';
          bar.setAttribute('role', 'img');
          bar.setAttribute('aria-label', (this.t.skin_left || 'noch {n}').replace('{n}', this.num(tier.min - best)));
          const fill = document.createElement('i');
          fill.style.width = Math.max(4, Math.min(100, Math.round(100 * best / tier.min))) + '%';
          bar.appendChild(fill);
          button.appendChild(bar);
        }
        box.appendChild(button);
        this.skinPreview(canvas, skin, open, true);
      });
    }
    skinCount() { return this.constructor.SKINS.filter(skin => this.skinOpen(skin)).length; }
    miniRow(row) {
      row.innerHTML = '';
      const best = this.flightBest();
      this.constructor.SKINS.forEach(skin => {
        const tier = this.constructor.TIERS[skin];
        const open = best >= tier.min;
        const cell = document.createElement('span');
        cell.className = 'axrt__skin' + (open ? '' : ' is-locked') + (skin === 'mask' ? ' is-base' : '') + (open && skin === this.skin ? ' is-on' : '');
        cell.style.setProperty('--rar', tier.c);
        const canvas = document.createElement('canvas');
        canvas.width = 126;
        canvas.height = 84;
        cell.appendChild(canvas);
        row.appendChild(cell);
        this.skinPreview(canvas, skin, open, true);
      });
    }
    buildSkins() {
      const total = this.constructor.SKINS.length;
      const count = this.skinCount() + '/' + total;
      if (this.p.skins) {
        this.p.skins.setAttribute('aria-label', this.t.skin || 'SKIN');
        this.skinRow(this.p.skins);
        this.querySelector('[data-skinx-count]').textContent = 'SKINS ' + count;
        this.querySelector('[data-skinx-best]').textContent = (this.t.coll_best || 'BEST') + ' ' + this.num(this.flightBest());
      }
      if (this.p.skincur) {
        const tier = this.constructor.TIERS[this.skin];
        const icon = this.p.skincur.querySelector('[data-skincur-icon]');
        icon.className = 'axrt__skin is-on' + (this.skin === 'mask' ? ' is-base' : '');
        icon.style.setProperty('--rar', tier.c);
        this.skinPreview(icon.querySelector('canvas'), this.skin, true, true);
        this.p.skincur.style.setProperty('--rar', tier.c);
        this.p.skincur.querySelector('[data-skincur-name]').textContent = (this.t.skins || {})[this.skin] || this.skin.toUpperCase();
        this.p.skincur.querySelector('[data-skincur-rar]').textContent = tier.r;
        this.p.skincur.querySelector('[data-skinx-open]').textContent = (this.t.skin_change || 'CHANGE SKIN') + ' (' + count + ')';
      }
      const coll = this.querySelector('[data-skin-coll]');
      if (coll) {
        this.miniRow(coll.querySelector('[data-coll-row]'));
        coll.querySelector('[data-coll-count]').textContent = 'SKINS ' + count;
        coll.querySelector('[data-coll-all]').textContent = (this.t.skin_all || 'ALL SKINS') + ' →';
      }
    }
    openSkins() {
      const box = this.p.skinx;
      if (!box) return;
      this.buildSkins();
      if (typeof box.showModal === 'function') { if (!box.open) box.showModal(); } else box.setAttribute('open', '');
      if (!this.dlg.open) document.documentElement.classList.add('axru-lock');
      requestAnimationFrame(() => (box.querySelector('[aria-checked="true"]') || box.querySelector('[data-skinx-close]'))?.focus({ preventScroll: true }));
    }
    closeSkins() {
      const box = this.p.skinx;
      if (!box) return;
      if (typeof box.close === 'function' && box.open) box.close(); else box.removeAttribute('open');
      if (!this.dlg.open) document.documentElement.classList.remove('axru-lock');
      this.buildSkins();
    }
    setSkin(skin) {
      if (this.constructor.SKINS.indexOf(skin) < 0 || this.state === 'play' || this.state === 'count') return;
      if (!this.skinOpen(skin)) { this.sfx('soft'); return; }
      this.skin = skin;
      this.save('skin', skin);
      this.querySelectorAll('[data-skins] [data-skin]').forEach(button => button.setAttribute('aria-checked', String(button.dataset.skin === skin)));
      this.sfx('tick');
      setTimeout(() => this.closeSkins(), 180);
    }
    showUnlocks(previous, score) {
      const box = this.querySelector('[data-unlock]');
      if (!box) return;
      const fresh = this.constructor.SKINS.filter(skin => { const min = this.constructor.TIERS[skin].min; return min > 0 && previous < min && score >= min; });
      if (!fresh.length) return;
      const names = this.t.skins || {};
      const top = fresh[fresh.length - 1];
      box.style.setProperty('--rar', this.constructor.TIERS[top].c);
      this.skinPreview(box.querySelector('canvas'), top, true);
      box.querySelector('[data-unlock-text]').textContent = (this.t.unlocked || 'NEW SKIN UNLOCKED') + ': ' + fresh.map(skin => names[skin] || skin.toUpperCase()).join(' · ');
      box.querySelector('[data-unlock-rar]').textContent = this.constructor.TIERS[top].r;
      box.hidden = false;
      this.buildSkins();
      this.sfx('go');
      this.track('skin_unlock', { skins: fresh.join(',') });
    }
    static PIX = {
      moon: ['..#####...', '.####.....', '####......', '###.......', '###.......', '###.......', '###.......', '####......', '.####.....', '..#####...'],
      sheep: ['...##.##.......', '..##########...', '.###########@@.', '###########@@@@', '##########@@@@@', '##########@-@@@', '.#########@@@@.', '..########.@@..', '...#.##.##.....']
    };
    pix(ctx, rows, s, ox, oy, colors) {
      rows.forEach((row, y) => {
        for (let x = 0; x < row.length; x += 1) {
          const c = colors[row[x]];
          if (c) { ctx.fillStyle = c; ctx.fillRect(ox + x * s, oy + y * s, s, s); }
        }
      });
    }
    // Rein optisch: Die Trefferflaeche bleibt bei allen Skins FLIGHT.pw x FLIGHT.ph um denselben Mittelpunkt.
    drawSkin(ctx, skin, t, wing) {
      if (skin === 'moon') {
        ctx.globalAlpha = 0.16 + 0.06 * Math.sin(t * 3);
        ctx.fillStyle = '#F2E6C4';
        ctx.beginPath(); ctx.arc(-2, 0, 17, 0, Math.PI * 2); ctx.fill();
        ctx.globalAlpha = 1;
        this.pix(ctx, this.constructor.PIX.moon, 2, -10, -10, { '#': '#F2E6C4' });
        ctx.fillStyle = '#C9B49A';
        ctx.fillRect(-6, -1, 3, 1);
        return;
      }
      if (skin === 'sun') {
        ctx.globalAlpha = 0.18;
        ctx.fillStyle = '#E8B97A';
        ctx.beginPath(); ctx.arc(0, 0, 17, 0, Math.PI * 2); ctx.fill();
        ctx.globalAlpha = 1;
        ctx.fillStyle = '#E8B97A';
        const turn = t * 0.8;
        for (let i = 0; i < 8; i += 1) {
          const a = turn + i * Math.PI / 4;
          const r = 12 + (i % 2 ? 1 : 3) + Math.sin(t * 6 + i) * 0.8;
          ctx.fillRect(Math.round(Math.cos(a) * r) - 1, Math.round(Math.sin(a) * r) - 1, 3, 3);
        }
        for (let y = -4; y <= 4; y += 1) for (let x = -4; x <= 4; x += 1) {
          const d = x * x + y * y;
          if (d > 18) continue;
          ctx.fillStyle = d > 10 ? '#E8B97A' : '#F6E3B4';
          ctx.fillRect(x * 2 - 1, y * 2 - 1, 2, 2);
        }
        ctx.fillStyle = '#8A5A2B';
        ctx.fillRect(-4, 1, 3, 1); ctx.fillRect(2, 1, 3, 1);
        return;
      }
      if (skin === 'meteor') {
        for (let i = 0; i < 10; i += 1) {
          const flick = Math.sin(t * 24 + i * 2.1);
          const h = Math.max(2, 12 - i);
          const x = -10 - i * 3;
          const y = -Math.round(h / 2) + Math.round(flick * (i > 2 ? 1.5 : 0.5));
          ctx.globalAlpha = Math.max(0.15, 1 - i * 0.085);
          ctx.fillStyle = i < 6 ? '#D0564F' : '#7A2E2A';
          ctx.fillRect(x, y, 3, h);
          if (i < 6 && h > 5) { ctx.fillStyle = '#F08A3C'; ctx.fillRect(x, y + 2, 3, h - 4); }
          if (i < 3 && h > 8) { ctx.fillStyle = '#F6E3B4'; ctx.fillRect(x, y + 4, 3, h - 8); }
        }
        for (let k = 0; k < 4; k += 1) {
          const p = (t * 3 + k * 0.27) % 1;
          ctx.globalAlpha = 1 - p;
          ctx.fillStyle = k % 2 ? '#F08A3C' : '#E8B97A';
          ctx.fillRect(Math.round(-14 - p * 30), Math.round(Math.sin(k * 7.3 + t * 2) * 7), 2, 2);
        }
        ctx.globalAlpha = 1;
        this.pix(ctx, ['..####..', '.######.', '##@###@#', '########', '#@####@#', '.######.', '..####..'], 2, -8, -7, { '#': '#8A7A66', '@': '#4A4036' });
        ctx.fillStyle = '#F08A3C';
        ctx.fillRect(-8, -3, 2, 6);
        return;
      }
      if (skin === 'comet') {
        for (let i = 0; i < 16; i += 1) {
          ctx.globalAlpha = Math.max(0, 0.75 - i * 0.045);
          ctx.fillStyle = i % 3 === 0 ? '#F6F2EA' : '#9FD8F2';
          const h = Math.max(1, 7 - Math.floor(i / 2.5));
          ctx.fillRect(-8 - i * 3, -Math.round(h / 2) + Math.round(Math.sin(t * 5 + i * 0.6)), 3, h);
        }
        ctx.globalAlpha = 0.22;
        ctx.fillStyle = '#9FD8F2';
        ctx.beginPath(); ctx.arc(0, 0, 13, 0, Math.PI * 2); ctx.fill();
        ctx.globalAlpha = 1;
        for (let y = -3; y <= 3; y += 1) for (let x = -3; x <= 3; x += 1) {
          const d = x * x + y * y;
          if (d > 11) continue;
          ctx.fillStyle = d > 5 ? '#9FD8F2' : '#F2FBFF';
          ctx.fillRect(x * 2 - 1, y * 2 - 1, 2, 2);
        }
        return;
      }
      if (skin === 'sheep') {
        ctx.fillStyle = '#121010';
        const leg = wing > 0.09 ? 2 : 0;
        ctx.fillRect(-7, 7 + leg, 2, 4); ctx.fillRect(-1, 7, 2, 4); ctx.fillRect(5, 7 + leg, 2, 4);
        this.pix(ctx, this.constructor.PIX.sheep, 2, -15, -9, { '#': '#F6F2EA', '@': '#3A352C', '-': '#C9B49A' });
        ctx.fillStyle = '#3A352C';
        ctx.fillRect(7, -9, 3, 2);
        ctx.fillStyle = '#C9B49A';
        if (wing > 0.09) { ctx.fillRect(-4, -14, 3, 5); ctx.fillRect(-1, -12, 4, 3); } else { ctx.fillRect(-6, -9, 8, 2); }
        return;
      }
      ctx.fillStyle = '#F6F2EA';
      if (wing > 0.09) { ctx.fillRect(-5, -15, 4, 8); ctx.fillRect(-1, -13, 6, 6); } else { ctx.fillRect(-7, -9, 11, 3); }
      ctx.fillStyle = '#C9B49A';
      ctx.fillRect(-19, -1, 6, 2);
      ctx.fillRect(-14, -7, 28, 14);
      ctx.fillStyle = '#121010';
      ctx.fillRect(-13, -6, 26, 12);
      ctx.fillStyle = '#C9B49A';
      ctx.fillRect(-8, 1, 5, 1); ctx.fillRect(-9, 0, 1, 1); ctx.fillRect(-3, 0, 1, 1);
      ctx.fillRect(3, 1, 5, 1); ctx.fillRect(2, 0, 1, 1); ctx.fillRect(8, 0, 1, 1);
    }
    flightOver() {
      cancelAnimationFrame(this.raf);
      const f = this.f;
      const score = this.flightScore();
      const seconds = Math.round(f.t * 10) / 10;
      this.state = 'over';
      this.dlg.classList.add('is-over');
      this.sfx('fail');
      try { navigator.vibrate?.(80); } catch (error) {}
      const previous = parseInt(this.load('best-flight'), 10) || 0;
      const newBest = score > previous;
      if (newBest) this.save('best-flight', String(score));
      if (newBest) this.buildSkins();
      const min = parseInt(this.dataset.fmin, 10) || 250;
      const monthCode = this.monthCode();
      this.track('done', { level: 'flight', score, seconds, zs: f.zs });
      let stats = (this.t.points || '') + ': <b>' + score + '</b> · Z ' + f.zs + ' · ' + this.fmt(seconds);
      stats += newBest ? ' · <b>' + (this.t.f_best || '') + '</b>' : ' · ' + (this.t.best || '') + ': ' + previous;
      this.later(() => {
        this.finish(score >= min ? this.t.f_win : this.t.f_over, stats);
        this.showUnlocks(previous, score);
        this.submitRun({ level: 'flight', ms: Math.round(f.t * 1000), score, dist: Math.round(f.dist * 10) / 10, zs: f.zs, flaps: f.flaps });
        if (monthCode && score >= min) {
          this.querySelector('[data-code]').textContent = monthCode;
          this.p.redeem.href = '/discount/' + encodeURIComponent(monthCode) + '?redirect=' + encodeURIComponent('/collections/the-masks');
          this.p.reward.hidden = false;
          this.track('reward_unlocked', { level: 'flight', score, month: monthCode.split('-')[1] || '' });
        } else if (monthCode) {
          this.p.stats.innerHTML += '<br><b>' + this.escape(this.fill(this.t.f_slow)) + '</b>';
          this.track('reward_missed', { level: 'flight', score });
        }
      }, 900);
    }
    lightUp(win) {
      const config = this.constructor.LEVELS[this.level];
      this.setLit(win, true);
      win.classList.add('is-new');
      this.litTotal += 1;
      if (!config.spread) return;
      const gen = win._gen;
      this.later(() => {
        if (this.state !== 'play' || win._gen !== gen || !win.classList.contains('is-lit')) return;
        const near = [[1, 0], [-1, 0], [0, 1], [0, -1]].map(([dr, dc]) => {
          const r = win._r + dr;
          const c = win._c + dc;
          return r >= 0 && r < win._rows && c >= 0 && c < win._cols ? this.windows[win._h + r * win._cols + c] : null;
        }).filter(item => item && !item.classList.contains('is-lit'));
        const next = near[Math.floor(Math.random() * near.length)];
        if (!next) return;
        this.lightUp(next);
        this.updateLit();
      }, config.spread);
    }
    tapCity(event) {
      if (this.kind !== 'city' || this.state !== 'play') return;
      const hit = event.target.closest('.axru__win');
      const x = event.clientX;
      const y = event.clientY;
      const pointer = !!(x || y);
      let target = hit && hit.classList.contains('is-lit') ? hit : null;
      if (!target && pointer) target = this.litNear(x, y, hit ? 6 : 12);
      if (!target) {
        if (hit) this.miss(hit);
        return;
      }
      this.setLit(target, false);
      const tapAt = performance.now();
      if (this.lastTap) this.gaps.push(tapAt - this.lastTap);
      this.lastTap = tapAt;
      this.taps = (this.taps || 0) + 1;
      this.sfx('off');
      const n = this.updateLit();
      if (n === 0) { this.cityDone(); return; }
      this.scheduleRelight();
    }
    cityDone() {
      const seconds = Math.round((performance.now() - this.t0) / 100) / 10;
      this.clearTimers();
      this.c.clock.textContent = this.fmt(seconds);
      this.c.toast.classList.remove('is-on');
      this.dlg.classList.add('is-asleep');
      this.later(() => this.sfx('win'), 150);
      const level = this.level;
      const previous = this.best(level);
      const newBest = !previous || seconds < previous;
      if (newBest) this.save('best-' + level, String(seconds));
      const record = this.record(level);
      let stats = ((this.t.levels || {})[level] || level) + ' · ' + (this.t.time || '') + ': <b>' + this.fmt(seconds) + '</b>';
      stats += newBest ? ' · <b>' + (this.t.new_best || '') + '</b>' : ' · ' + (this.t.best || '') + ': ' + this.fmt(previous);
      if (record && seconds < record) stats += '<br><b>' + (this.t.beat || '') + '</b>';
      else if (record) stats += '<br>' + (this.t.record || '') + ': ' + this.fmt(record) + (this.dataset.recordName ? ' (' + this.escape(this.dataset.recordName) + ')' : '');
      this.track('done', { level, seconds, new_best: newBest, lives: this.lives });
      this.later(() => {
        this.finish(this.t.asleep, stats);
        const next = { easy: 'medium', medium: 'extreme' }[level];
        if (next) {
          this.save('level', next);
          this.querySelector('[data-next-label]').textContent = (this.t.next || '').replace('{lvl}', (this.t.levels || {})[next] || next);
          this.p.next.hidden = false;
          this.p.again.classList.remove('axru__play', 'axru__play--light');
          this.p.again.classList.add('axru__link');
          requestAnimationFrame(() => this.p.next.focus({ preventScroll: true }));
        }
        this.submitRun(this.cityBody(seconds));
        const max = parseFloat(String(this.dataset.sec || '').replace(',', '.')) || 14;
        const monthCode = this.monthCode();
        if (level === 'extreme' && monthCode && seconds > max) {
          this.p.stats.innerHTML += '<br><b>' + this.escape(this.fill(this.t.too_slow)) + '</b>';
          this.track('reward_missed', { level, seconds });
        }
        if (level === 'extreme' && monthCode && seconds <= max) {
          const code = monthCode;
          if (code) {
            this.querySelector('[data-code]').textContent = code;
            this.p.redeem.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent('/collections/the-masks');
            this.p.reward.hidden = false;
            this.track('reward_unlocked', { level, seconds, month: code.split('-')[1] || '' });
          }
        }
      }, 1600);
    }
  });
}
if (!customElements.get('ax-lb')) {
  customElements.define('ax-skin-strip', class extends HTMLElement {
    static get R() { return customElements.get('ax-room-unwind'); }
    static get SKINS() { return this.R.SKINS; }
    static get TIERS() { return this.R.TIERS; }
    static get PIX() { return this.R.PIX; }
    connectedCallback() {
      const R = this.constructor.R;
      const row = this.querySelector('[data-strip-row]');
      if (!R || !row || row.childElementCount) return;
      ['drawSkin', 'pix', 'skinPreview'].forEach(name => { this[name] = R.prototype[name]; });
      let best = 0;
      try { best = parseInt(localStorage.getItem('axru-best-flight'), 10) || 0; } catch (error) {}
      R.SKINS.forEach(skin => {
        const tier = R.TIERS[skin];
        const open = best >= tier.min;
        const cell = document.createElement('span');
        cell.className = 'axrt__skin' + (open ? '' : ' is-locked') + (skin === 'mask' ? ' is-base' : '');
        cell.style.setProperty('--rar', tier.c);
        const canvas = document.createElement('canvas');
        canvas.width = 126;
        canvas.height = 84;
        cell.appendChild(canvas);
        row.appendChild(cell);
        this.skinPreview(canvas, skin, open, true);
      });
    }
  });
  customElements.define('ax-lb', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.levels = ['extreme', 'flight'];
      this.cache = {};
      this.more = this.querySelector('[data-lb-more]');
      this.edit = this.querySelector('[data-lb-edit]');
      this.form = this.querySelector('[data-lb-form]');
      this.onClick = event => {
        if (event.target.closest('[data-lb-more]')) { this.classList.toggle('is-open'); this.draw(); return; }
        if (event.target.closest('[data-lb-edit]')) {
          this.form.hidden = !this.form.hidden;
          this.querySelector('[data-lb-bad]').textContent = '';
          const input = this.form.querySelector('input');
          if (!this.form.hidden) { input.value = this.store('nick') || ''; input.focus(); }
        }
      };
      this.onSubmit = event => { event.preventDefault(); this.rename(); };
      this.onRefresh = () => { this.cache = {}; this.load(true); };
      this.addEventListener('click', this.onClick);
      this.form.addEventListener('submit', this.onSubmit);
      window.addEventListener('axlb:refresh', this.onRefresh);
      this.load();
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.form.removeEventListener('submit', this.onSubmit);
      window.removeEventListener('axlb:refresh', this.onRefresh);
      this.ready = false;
    }
    store(key, value) {
      try { if (value === undefined) return localStorage.getItem('axru-' + key); localStorage.setItem('axru-' + key, value); } catch (error) { return null; }
    }
    mine() {
      try { const runs = JSON.parse(this.store('runs') || '[]'); return Array.isArray(runs) ? runs : []; } catch (error) { return []; }
    }
    load(fresh) {
      const base = this.dataset.board.replace(/\/$/, '');
      return Promise.all(this.levels.map(async level => {
        try {
          const res = await fetch(base + '/top?level=' + level + '&limit=10' + (fresh ? '&t=' + Date.now() : ''));
          if (!res.ok) throw new Error(res.status);
          this.cache[level] = await res.json();
        } catch (error) {
          this.cache[level] = { error: true };
        }
      })).then(() => this.draw());
    }
    fmt(ms) {
      const seconds = ms / 1000;
      if (seconds < 60) return seconds.toFixed(1) + ' s';
      const m = Math.floor(seconds / 60);
      const s = (seconds - m * 60).toFixed(1);
      return m + ':' + (s.length < 4 ? '0' + s : s);
    }
    cell(text, className) {
      const td = document.createElement('td');
      td.textContent = text;
      if (className) td.className = className;
      return td;
    }
    draw() {
      const ids = new Set(this.mine().map(run => run.id));
      const nick = String(this.store('nick') || '').toUpperCase();
      const open = this.classList.contains('is-open');
      let longest = 0;
      let meVisible = false;
      this.levels.forEach(level => {
        const body = this.querySelector('[data-lb-body="' + level + '"]');
        const data = this.cache[level];
        if (!body || !data) return;
        body.innerHTML = '';
        const rows = data.error ? [] : (data.allTime || []).slice(0, 10);
        if (!rows.length) {
          const tr = document.createElement('tr');
          const td = this.cell(data.error ? this.dataset.err : this.dataset.empty, 'axlb2__msg');
          td.colSpan = 3;
          tr.appendChild(td);
          body.appendChild(tr);
          return;
        }
        longest = Math.max(longest, rows.length);
        rows.forEach((row, index) => {
          const tr = document.createElement('tr');
          const me = ids.has(row.id) || (!!nick && String(row.name || '').toUpperCase() === nick);
          if (me) { tr.className = 'is-me'; if (index < 5 || open) meVisible = true; }
          tr.append(
            this.cell(String(index + 1).padStart(2, '0')),
            this.cell(row.name || this.dataset.anon, row.name ? '' : 'is-anon'),
            this.cell(data.kind === 'score' ? String(row.score) : this.fmt(row.score))
          );
          body.appendChild(tr);
        });
      });
      this.more.hidden = longest <= 5;
      this.more.textContent = open ? 'TOP 5 ↑' : 'TOP 10 ↓';
      this.more.setAttribute('aria-expanded', String(open));
      this.edit.hidden = !meVisible;
      if (!meVisible) this.form.hidden = true;
    }
    async rename() {
      const bad = this.querySelector('[data-lb-bad]');
      const name = String(this.form.querySelector('input').value || '').replace(/\s+/g, ' ').trim();
      bad.textContent = '';
      if (!/^[A-Za-z0-9ÄÖÜäöüßÀ-ÿ _.\-]{2,16}$/.test(name)) { bad.textContent = this.dataset.bad || ''; return; }
      const base = this.dataset.board.replace(/\/$/, '');
      const runs = this.mine().map(run => ({ id: run.id, token: run.token }));
      try {
        const res = await fetch(base + '/rename', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ name, runs }) });
        if (res.status === 422) { bad.textContent = this.dataset.bad || ''; return; }
        if (res.status === 404) {
          for (const run of this.mine().filter(item => Date.now() - item.ts < 55 * 60 * 1000)) {
            const old = await fetch(base + '/run/' + run.id, { method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token: run.token, name }) });
            if (old.status === 422) { bad.textContent = this.dataset.bad || ''; return; }
          }
        }
      } catch (error) {}
      this.store('nick', name.toUpperCase());
      this.store('nick-asked', '1');
      this.form.hidden = true;
      this.cache = {};
      this.load(true);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aurvex-wall-of-fame"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ax-wall-of-fame')) {
  customElements.define('ax-wall-of-fame', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.onClick = event => {
        const tab = event.target.closest('[data-tab]');
        if (!tab) return;
        this.querySelectorAll('[data-tab]').forEach(item => item.setAttribute('aria-selected', String(item === tab)));
        this.querySelectorAll('[data-list]').forEach(list => { list.hidden = list.dataset.list !== tab.dataset.tab; });
      };
      this.addEventListener('click', this.onClick);
      this.onPending = () => this.showEntry(true);
      window.addEventListener('axwf:pending', this.onPending);
      this.form = this.querySelector('form');
      if (this.querySelector('[data-posted]')) {
        try { sessionStorage.removeItem('axwf-pending'); } catch (error) {}
        requestAnimationFrame(() => this.scrollIntoView({ block: 'start' }));
        return;
      }
      this.onSubmit = event => {
        const nick = this.querySelector('[data-nick]');
        const ok = nick && this.cleanName(nick.value);
        this.querySelector('[data-bad-msg]').hidden = !!ok;
        if (!ok) { event.preventDefault(); nick?.focus(); return; }
        nick.value = ok;
      };
      this.form?.addEventListener('submit', this.onSubmit);
      this.showEntry(location.hash === '#wall');
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      window.removeEventListener('axwf:pending', this.onPending);
      this.form?.removeEventListener('submit', this.onSubmit);
      this.ready = false;
    }
    pending() {
      try {
        const data = JSON.parse(sessionStorage.getItem('axwf-pending') || 'null');
        if (data && data.seconds > 0 && Date.now() - data.ts < 30 * 60 * 1000) return data;
      } catch (error) {}
      return null;
    }
    cleanName(value) {
      const name = String(value || '').replace(/\s+/g, ' ').trim();
      if (!/^[A-Za-z0-9ÄÖÜäöüßÀ-ÿ _.\-]{2,16}$/.test(name)) return '';
      const flat = name.toLowerCase().replace(/0/g, 'o').replace(/[1!|]/g, 'i').replace(/3/g, 'e').replace(/4/g, 'a').replace(/5/g, 's').replace(/7/g, 't').replace(/[^a-zäöüß]/g, '');
      const blocked = ['fuck', 'fick', 'shit', 'scheiss', 'hure', 'nazi', 'hitler', 'heil', 'nigg', 'neger', 'fotze', 'wichs', 'porn', 'sex', 'cunt', 'bitch', 'schlampe', 'arsch', 'penis', 'vagina', 'admin', 'aurvex', 'kanake', 'schwuchtel', 'spast', 'retard', 'putain', 'salope', 'connard', 'encule', 'pute', 'merde'];
      return blocked.some(word => flat.includes(word)) ? '' : name;
    }
    showEntry(scroll) {
      const entry = this.querySelector('[data-entry]');
      const data = this.pending();
      if (!entry || !data) return;
      const m = Math.floor(data.seconds / 60);
      const s = (data.seconds - m * 60).toFixed(1);
      const time = m + ':' + (s.length < 4 ? '0' + s : s);
      this.querySelector('[data-mine]').textContent = time;
      this.querySelector('[data-f="time"]').value = time + ' (' + data.seconds + ' s)';
      this.querySelector('[data-f="month"]').value = data.month || '';
      this.querySelector('[data-f="details"]').value = 'WALL OF FAME · GOODNIGHT, CITY EXTREM\nZeit: ' + data.seconds + ' s\nMonat: ' + data.month + '\nTreffer: ' + data.taps + ' · Fehlklicks: ' + data.misses + ' · Leben übrig: ' + data.lives + ' · Wieder angeschaltet: ' + data.relights + '\nSchnellster Abstand zwischen zwei Treffern: ' + data.minGap + ' ms · Durchschnitt: ' + data.avgGap + ' ms\nGespielt: ' + new Date(data.ts).toISOString() + '\nGerät: ' + data.device;
      entry.hidden = false;
      if (scroll) requestAnimationFrame(() => entry.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' }));
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
